import { CardDashboard, CardContent, MarkdownPreview } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import { ProgramOverviewProps } from './ProgramOverview.types'

import styles from './ProgramOverview.module.scss'

export const ProgramOverview = ({ description }: Readonly<ProgramOverviewProps>) => {
  const { t } = useTranslation()

  return (
    <CardDashboard title={t('grants.grantDetails.programOverview.title')} data-testid="program-overview-card">
      <CardContent testId="program-description">
        <MarkdownPreview content={description} className={styles.markdown} fontSize="bodySmall" />
      </CardContent>
    </CardDashboard>
  )
}
